import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Ship,
  Sparkles,
  MessageSquare,
  Layers,
  Image,
  HelpCircle,
  Compass,
  Sailboat,
  PartyPopper,
  Zap,
  CalendarCheck,
  Mail,
  Newspaper,
  UserPlus,
  Clock,
  Anchor,
  UtensilsCrossed,
  LogOut,
  Heart
} from "lucide-react";

const Sidebar = () => {
  return (
    <aside className="cms-sidebar">

      <div className="cms-logo">
       <img src="/assets/img/indiaboatslogo.png" alt="" />
      </div>

      <nav className="cms-nav">

        <div className="cms-nav-section">
          <span className="cms-nav-label">
            MAIN
          </span>

          <NavLink
            to="/admin"
            end
            className="cms-nav-link"
          >
            <LayoutDashboard size={19} />
            <span>Dashboard</span>
          </NavLink>
        </div>


        <div className="cms-nav-section">

          <span className="cms-nav-label">
            WEBSITE CONTENT
          </span>

          <NavLink
            to="/admin/signature-experience"
            className="cms-nav-link"
          >
            <Sparkles size={19} />
            <span> Home - Hero Section</span>
          </NavLink>

          <NavLink
            to="/admin/most-loved-experiences"
            className="cms-nav-link"
          >
            <Heart size={19} />
            <span>Home - Most Loved Yacht Experiences</span>
          </NavLink>

          <NavLink
            to="/admin/packages"
            className="cms-nav-link"
          >
            <Ship size={19} />
            <span>Packages - Featured Experiences</span>
          </NavLink>

         
 
          

          

          <NavLink
            to="/admin/browse-packages"
            className="cms-nav-link"
          >
            <Layers size={19} />
            <span>Packages - Browse Packages</span>
          </NavLink>

          <NavLink
            to="/admin/testimonials"
            className="cms-nav-link"
          >
            <MessageSquare size={19} />
            <span>Testimonials</span>
          </NavLink>

          <NavLink
            to="/admin/private-yacht"
            className="cms-nav-link"
          >
            <Sailboat size={19} />
            <span>Private Yacht</span>
          </NavLink>

          <NavLink
            to="/admin/yacht-parties"
            className="cms-nav-link"
          >
            <PartyPopper size={19} />
            <span>Yacht Parties</span>
          </NavLink>

          <NavLink
            to="/admin/speed-boats"
            className="cms-nav-link"
          >
            <Zap size={19} />
            <span>Speed Boats</span>
          </NavLink>

          {/* <NavLink
            to="/admin/experiences"
            className="cms-nav-link"
          >
            <Compass size={19} />
            <span>Experiences</span>
          </NavLink> */}

          <NavLink
            to="/admin/time-slots"
            className="cms-nav-link"
          >
            <Clock size={19} />
            <span>Boat Time Management</span>
          </NavLink>

          

          <NavLink
            to="/admin/speedboat-times"
            className="cms-nav-link"
          >
            <Clock size={19} />
            <span>Speed Boat Time Slots</span>
          </NavLink>

          <NavLink
            to="/admin/yacht-details"
            className="cms-nav-link"
          >
            <Anchor size={19} />
            <span>Yacht Prices</span>
          </NavLink>

          <NavLink
            to="/admin/addons"
            className="cms-nav-link"
          >
            <UtensilsCrossed size={19} />
            <span>Addons</span>
          </NavLink>

          <NavLink
            to="/admin/faqs"
            className="cms-nav-link"
          >
            <HelpCircle size={19} />
            <span>FAQs</span>
          </NavLink>

          <NavLink
            to="/admin/gallery"
            className="cms-nav-link"
          >
            <Image size={19} />
            <span>Gallery</span>
          </NavLink>

        </div>


        <div className="cms-nav-section">

          <span className="cms-nav-label">
            MANAGEMENT
          </span>

          <NavLink
            to="/admin/confirmed-bookings"
            className="cms-nav-link"
          >
            <CalendarCheck size={19} />
            <span>Confirmed Booking</span>
          </NavLink>

          <NavLink
            to="/admin/enquiries"
            className="cms-nav-link"
          >
            <Mail size={19} />
            <span>Enquiries</span>
          </NavLink>

          <NavLink
            to="/admin/newsletter"
            className="cms-nav-link"
          >
            <Newspaper size={19} />
            <span>Newsletter</span>
          </NavLink>

          <NavLink
            to="/admin/signups"
            className="cms-nav-link"
          >
            <UserPlus size={19} />
            <span>Signups</span>
          </NavLink>

        </div>

      </nav>


      <div className="cms-sidebar-bottom">

        <button
  type="button"
  className="cms-logout-btn"
  onClick={() => {

    localStorage.removeItem(
      "indiaboatsAdminToken"
    );

    localStorage.removeItem(
      "indiaboatsAdmin"
    );

    window.location.href =
      "/admin/login";

  }}
>
          <LogOut size={19} />
          <span>Logout</span>
        </button>

      </div>

    </aside>
  );
};

export default Sidebar;